import defaultTheme from './default'
const compareTheMarketTheme = { ...defaultTheme }

export default compareTheMarketTheme
